import React from 'react'

const Price = ({ strike_price, price, prices, offer_price, discount_rate, price_label, skul, stockLabel, stockCircle, tdcLabel, tdc }) => {

    return (
        <>
            <div className='col-12 d-flex justify-content-between'>
                <p style={{ fontSize: "1.5rem", fontWeight: "bold" }}>{skul}</p>{tdc > 0 ? <p style={{ color: "green", fontWeight: "bold" }}>{tdcLabel}</p> : <p style={{ fontSize: "1.3rem", fontWeight: "bold" }} className='mr-3'><span class={`status-circle ${stockCircle}`}></span>{stockLabel}</p>}
            </div>
            {
                strike_price &&
                parseFloat(strike_price) !==
                parseFloat(price) && (
                    <div className='col-12'>
                        <h4 className="barrato">
                            &euro; {strike_price}
                        </h4>
                    </div>
                )
            }
            {
                offer_price !== null && discount_rate > 0 && (
                    <div className="col-12 product-price">
                        <h3 style={{ fontWeight: "bold" }}>
                            <span
                                className="barrato"
                                style={{ fontSize: "2rem", color: "grey" }}
                            >
                                €{price}
                            </span>{" "}
                            {discount_rate !== undefined &&
                                parseFloat(discount_rate) !== 0 &&
                                discount_rate !== null && (
                                    <span className="discount-rate">
                                        {discount_rate}%
                                    </span>
                                )}
                        </h3>
                    </div>
                )
            }
            <div className="col-12 product-price">
                <h3 style={{ fontWeight: "bold" }}>
                    <span style={{ fontSize: "1.8rem" }}>

                        {offer_price
                            ? `€ ${parseFloat(offer_price).toFixed(2).toString().replace(".", ",")}`
                            : price_label}
                    </span>{" "}
                    {
                        discount_rate !== undefined &&
                        parseFloat(discount_rate) !== 0 &&
                        discount_rate !== null && (
                            <span className="discount-rate">
                                {discount_rate}%
                            </span>
                        )
                    }
                </h3>
            </div>

            {prices.length > 1 && <div className='col-12 py-1'>{prices.map(p => <p style={{ marginRight: "5px" }} key={p.from}>
                <span style={{ fontWeight: "bold" }}>
                    &euro;{" "}
                    {parseFloat(p.price)
                        .toFixed(2)
                        .replace(".", ",")}
                </span>{" "}
                per quantita:{" "}
                <span style={{ fontStyle: "italic" }}>{p.from}</span>
            </p>)}</div>}
        </>
    )
}

export default Price